<template>
  <div>
    <div class="w-full flex items-center justify-between">
      <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase">
        Prescrição
      </h1>

      <div>
        <div class="relative group inline-block">
          <button
            class="flex items-end font-roboto font-medium btn-primary uppercase"
            :class="!token ? 'bg-gray-400 cursor-not-allowed' : ''"
            :disabled="!token || isLoadMemed"
            @click.prevent="token ? openModalEdit() : null"
          >
            <font-awesome-icon icon="fa-plus" class="text-white text-lg mr-2" />
            Nova Prescrição
          </button>
          <div
            v-if="!token"
            class="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 w-[240px] px-3 py-2 text-sm text-red-600 bg-red-100 border border-red-300 rounded shadow-md opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-50 text-center leading-snug"
          >
            Memed temporariamente fora do ar!
          </div>
        </div>

        <modal-edit ref="modalEdit" title="Vinculado Atendimento" no-request>
          <template #form>
            <template v-if="doctorStatus == 'Inativo'">
              <p class="">
                Seu perfil está inativo e por isso não podera gerar novas
                prescrições!
              </p>
            </template>

            <select-input
              v-else
              v-model="appointmentId"
              class="lg:pr-6 w-full lg:w-1/2"
              label="Atendimento vinculado"
            >
              <option :value="null" disabled class="hidden invisible">
                Atendimento vinculado
              </option>

              <option
                v-for="(value, name, index) in appointments()"
                :key="name"
                :value="name"
              >
                {{ $filters.formatDateTime(value, "dd/MM/yyyy - HH:mm") }}
              </option>
            </select-input>
          </template>

          <template #footer>
            <button
              type="button"
              class="px-6 py-2.5 bg-gray-600 text-white font-roboto font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-700 hover:shadow-lg focus:bg-gray-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-800 active:shadow-lg transition duration-150 ease-in-out"
              @click="close"
            >
              Cancelar
            </button>

            <button
              type="submit"
              class="btn-primary px-6 py-2.5 text-xs leading-tight uppercase ml-1"
              @click="handleNewPrescrition"
            >
              Prosseguir
            </button>
          </template>
        </modal-edit>
      </div>
    </div>

    <Tabs
      :selected-item-index="selectedTab"
      :items="tabsIndex"
      item-class="px-2"
    >
      <template #content.exames>
        <div class="w-full py-4 mt-3">
          <data-table
            v-if="loadTable"
            v-model:columns="columns"
            :disable-search="true"
            :route="`/patients/detail/${patient.id}/prescritions?filter=exame`"
            no-data-label="Nenhuma prescrição cadastrada"
            no-result-label="Nenhuma prescrição encontrada"
          >
            <template #table.cell.content.actions="{ value, row }">
              <div>
                <button
                  v-if="row.hasFile"
                  type="button"
                  class="w-6 h-6 mr-4"
                  @click="handleDownloadRevenue(row.linkdocument)"
                >
                  <font-awesome-icon
                    icon="fa-download"
                    class="text-primary text-lg cursor-pointer"
                  />
                </button>

                <button
                  type="button"
                  class="w-6 h-6 mr-4"
                  @click="handleSharePrescription(row.id)"
                >
                  <font-awesome-icon
                    icon="fa-share-from-square"
                    class="text-primary text-lg cursor-pointer"
                  />
                </button>

                <button
                  type="button"
                  class="w-6 h-6"
                  @click="handleDeletePrescrition(row.id)"
                >
                  <font-awesome-icon
                    icon="fa-trash-can"
                    class="text-red-600 text-lg cursor-pointer"
                  />
                </button>
              </div>
            </template>

            <template #grid.content.body.actions="{ value, row }">
              <button
                v-if="row.hasFile"
                type="button"
                class="py-2 px-4 mb-2 w-full bg-primary text-white rounded cursor-pointer min-[510px]:w-[200px] min-[510px]:mr-2"
                @click="handleDownloadRevenue(row.linkdocument)"
              >
                <font-awesome-icon icon="fa-download" class="text-base" />
                <span class="text-base ml-2">Baixar Prescrição</span>
              </button>

              <button
                type="button"
                class="w-6 h-6 mr-4"
                @click="handleSharePrescription(row.id)"
              >
                <font-awesome-icon
                  icon="fa-share-from-square"
                  class="text-primary text-lg cursor-pointer"
                />
              </button>

              <button
                type="button"
                class="py-2 px-4 w-full bg-red-600 text-white rounded cursor-pointer min-[510px]:w-[200px]"
                @click="handleDeletePrescrition(row.id)"
              >
                <font-awesome-icon icon="fa-trash-can" class="text-base" />
                <span class="text-base ml-2">Deletar Prescrição</span>
              </button>
            </template>
          </data-table>
        </div>
      </template>

      <template #content.prescritions>
        <div class="w-full py-4 mt-3">
          <data-table
            v-if="loadTable"
            v-model:columns="columns"
            :disable-search="true"
            :route="`/patients/detail/${patient.id}/prescritions?filter=medicamentos`"
            no-data-label="Nenhuma prescrição cadastrada"
            no-result-label="Nenhuma prescrição encontrada"
          >
            <template #table.cell.content.actions="{ value, row }">
              <div>
                <button
                  v-if="row.hasFile"
                  type="button"
                  class="w-6 h-6 mr-4"
                  @click="handleDownloadRevenue(row.linkdocument)"
                >
                  <font-awesome-icon
                    icon="fa-download"
                    class="text-primary text-lg cursor-pointer"
                  />
                </button>

                <button
                  type="button"
                  class="w-6 h-6 mr-4"
                  @click="handleSharePrescription(row.id)"
                >
                  <font-awesome-icon
                    icon="fa-share-from-square"
                    class="text-primary text-lg cursor-pointer"
                  />
                </button>

                <button
                  type="button"
                  class="w-6 h-6"
                  @click="handleDeletePrescrition(row.id)"
                >
                  <font-awesome-icon
                    icon="fa-trash-can"
                    class="text-red-600 text-lg cursor-pointer"
                  />
                </button>
              </div>
            </template>

            <template #grid.content.body.actions="{ value, row }">
              <button
                v-if="row.hasFile"
                type="button"
                class="py-2 px-4 mb-2 w-full bg-primary text-white rounded cursor-pointer min-[510px]:w-[200px] min-[510px]:mr-2"
                @click="handleDownloadRevenue(row.linkdocument)"
              >
                <font-awesome-icon icon="fa-download" class="text-base" />
                <span class="text-base ml-2">Baixar Prescrição</span>
              </button>

              <button
                type="button"
                class="w-6 h-6 mr-4"
                @click="handleSharePrescription(row.id)"
              >
                <font-awesome-icon
                  icon="fa-share-from-square"
                  class="text-primary text-lg cursor-pointer"
                />
              </button>

              <button
                type="button"
                class="py-2 px-4 w-full bg-red-600 text-white rounded cursor-pointer min-[510px]:w-[200px]"
                @click="handleDeletePrescrition(row.id)"
              >
                <font-awesome-icon icon="fa-trash-can" class="text-base" />
                <span class="text-base ml-2">Deletar Prescrição</span>
              </button>
            </template>
          </data-table>
        </div>
      </template>

      <template #content.attestation>
        <div class="w-full py-4 mt-3">
          <data-table
            v-if="loadTable"
            v-model:columns="columns"
            :disable-search="true"
            :route="`/patients/detail/${patient.id}/prescritions?filter=atestado`"
            no-data-label="Nenhuma prescrição cadastrada"
            no-result-label="Nenhuma prescrição encontrada"
          >
            <template #table.cell.content.actions="{ value, row }">
              <div>
                <button
                  v-if="row.hasFile"
                  type="button"
                  class="w-6 h-6 mr-4"
                  @click="handleDownloadRevenue(row.linkdocument)"
                >
                  <font-awesome-icon
                    icon="fa-download"
                    class="text-primary text-lg cursor-pointer"
                  />
                </button>

                <button
                  type="button"
                  class="w-6 h-6 mr-4"
                  @click="handleSharePrescription(row.id)"
                >
                  <font-awesome-icon
                    icon="fa-share-from-square"
                    class="text-primary text-lg cursor-pointer"
                  />
                </button>

                <button
                  type="button"
                  class="w-6 h-6"
                  @click="handleDeletePrescrition(row.id)"
                >
                  <font-awesome-icon
                    icon="fa-trash-can"
                    class="text-red-600 text-lg cursor-pointer"
                  />
                </button>
              </div>
            </template>

            <template #grid.content.body.actions="{ value, row }">
              <button
                v-if="row.hasFile"
                type="button"
                class="py-2 px-4 mb-2 w-full bg-primary text-white rounded cursor-pointer min-[510px]:w-[200px] min-[510px]:mr-2"
                @click="handleDownloadRevenue(row.linkdocument)"
              >
                <font-awesome-icon icon="fa-download" class="text-base" />
                <span class="text-base ml-2">Baixar Prescrição</span>
              </button>

              <button
                type="button"
                class="w-6 h-6 mr-4"
                @click="handleSharePrescription(row.id)"
              >
                <font-awesome-icon
                  icon="fa-share-from-square"
                  class="text-primary text-lg cursor-pointer"
                />
              </button>

              <button
                type="button"
                class="py-2 px-4 w-full bg-red-600 text-white rounded cursor-pointer min-[510px]:w-[200px]"
                @click="handleDeletePrescrition(row.id)"
              >
                <font-awesome-icon icon="fa-trash-can" class="text-base" />
                <span class="text-base ml-2">Deletar Prescrição</span>
              </button>
            </template>
          </data-table>
        </div>
      </template>
    </Tabs>
  </div>
</template>

<script>
import { useForm } from '@inertiajs/inertia-vue3'

import DataTable from '@/Shared/Components/DataTable'
import Tabs from '@/Shared/Components/Tabs/Tabs'

import SelectInput from '@/Shared/Fields/SelectInput'
import ModalEdit from '@/Shared/Modal/ModalEdit'

import { useAppointmentStore } from '@/Store/Appointment'

const tabsIndex = [
  {
    idTab: 'prescritions',
    title: 'Prescricões',
  },
  {
    idTab: 'exames',
    title: 'Exames',
  },
  {
    idTab: 'attestation',
    title: 'Atestados',
  },
]

const columns = [
  {
    uniqid: 'appointment',
    label: 'Atendimento',
    field: 'appointment.date_start',
    visible: true,
    sortable: true,
    classes: 'p-3 border-b text-sm w-full align-top',
    headerClass: 'px-2 py-4 text-left w-full',
    format: (val, row) =>
      row.appointment?.date_start.replace(
        /(\d{4})\-(\d{2})\-(\d{2})/,
        '$3/$2/$1',
      ),
  },
  {
    uniqid: 'prescrition_date',
    label: 'Data de emissão',
    field: 'date',
    visible: true,
    sortable: false,
    classes: 'p-3 border-b text-sm w-full align-top',
    headerClass: 'px-2 py-4 text-left w-full',
    format: (val, row) => new Date(val).toLocaleDateString('pt-BR'),
  },
  {
    uniqid: 'medicines',
    label: 'Descrição',
    field: 'medicines',
    visible: true,
    sortable: false,
    classes: 'p-3 border-b text-sm w-full align-top break-words teste',
    headerClass: 'px-2 py-4 text-left w-full',
    format: (val, row) => val.map((v) => v.name).join(', '),
  },
  {
    uniqid: 'actions',
    label: 'Ações',
    field: 'id',
    visible: true,
    align: 'center',
    classes: 'py-3 border-b w-full',
    headerClass: 'p-4 w-full',
  },
]

export default {
  components: {
    Tabs,
    DataTable,
    SelectInput,
    ModalEdit,
  },
  inject: [
    'patient',
    'memedapiurl',
    'appointments',
    'ahlifeAddress',
    'doctorStatus',
    'memedjavascript',
    'loadOptions',
    'isLoadMemed',
  ],

  props: ['token'],

  data() {
    return {
      appointmentId: '',
      selectedTab: 0,
      tabsIndex,
      columns,
      loadTable: true,
    }
  },

  watch: {
    /**
     * If the professional try create prescription before 
     * the memed module is loded. Then this watch will call method to
     * set patient after mounted hook.
     */
    isLoadMemed() {
      this.setPatientAfterLoadingModule()
    },

    appointmentId(newValue, oldValue) {
      const appointmentStore = useAppointmentStore()
      appointmentStore.setPrescriptionAppointment(this.appointmentId)
    },
  },

  mounted() {
    window.MdHub.event.add('prescricaoImpressa', this.handleEmitPrescrition)
    this.setPatientAfterLoadingModule()
  },

  methods: {
    setPatientAfterLoadingModule: function () {
      if (this.isLoadMemed)
        return
    
      
      const patient = {
        external_id: this.patient.id,
        nome: this.patient.user.name,
        cpf: this.patient.cpf,
        telefone: this.patient.phone,
        data_nascimento: this.patient.birthdate.split('-').reverse().join('/'),
        endereco: `${this.patient.address.street}, ${this.patient.address.number}`,
        cidade: this.patient.address.city,
      }

      if (window.MdHub) {
        window.MdHub.command.send(
          'plataforma.prescricao',
          'setPaciente',
          patient,
        )
      }
    },

    handleNewPrescrition: function () {
      if (
        this.appointmentId.length > 0 &&
        window.MdHub &&
        this.doctorStatus != 'Inativo'
      ) {
        window.MdHub.module.show('plataforma.prescricao')
        this.$refs.modalEdit.close()
      }
    },

    handleSharePrescription: function (prescritionId) {
      this.$inertia.get(
        `/patients/prescriptions/${prescritionId}/re-send`,
        {},
        {
          onSuccess: () =>
            this.$toast.success('A prescrição foi enviada com sucesso'),
          onError: () =>
            this.$toast.error('Erro ao enviar prescrição, tente novamente'),
        },
      )
    },

    handleEmitPrescrition: function (prescritionData) {
      const appointmentStore = useAppointmentStore()
      const appointmentId = appointmentStore.prescription_appointment

      const form = useForm({
        prescritionId: prescritionData.prescricao.id,
        appointmentId,
        medicines: prescritionData.prescricao.medicamentos.map((medicine) => ({
          name: medicine.titulo,
          composition: medicine.descricao,
          description: medicine.sanitized_posology,
          type: medicine.tipo,
        })),
      })

      form.post(`/patients/prescriptions/${this.patient.id}`)
      this.reloadTable()
    },

    openModalEdit() {
      this.appointmentId = ''
      this.$refs.modalEdit.openModalEdit({})
    },

    close() {
      this.$refs.modalEdit.close()
    },

    handleDeletePrescrition: function (id) {
      const formDelete = useForm({ id })
      formDelete.delete('/patients/prescriptions/' + id, {
        onFinish: () => this.reloadTable(),
      })
    },

    handleDownloadRevenue: function (linkdocument) {
      try {
        window.open(`/pdf-view?link=${linkdocument}&type=pdf`, '_blank')
      } catch (err) {
        this.$toast.warning('Não é possivel gerar o link de download')
      }
    },

    reloadTable() {
      this.loadTable = false
      this.loadOptions()
      setTimeout(() => (this.loadTable = true), 10)
    },
  },
}
</script>
